import { types } from 'mobx-state-tree';
import createService from '../../../utils/NeDBService';

export const Registration = types.model('registrations', {
  name: types.maybe(types.string),
  specialty: types.maybe(types.string),
  institution: types.maybe(types.string),
  mobile: types.maybe(types.string),
  email: types.maybe(types.string),
  numberOfAccompanyingPerson: types.maybe(types.string),
  abstract: types.maybe(types.string),
  degree: types.maybe(types.string),
  designation: types.maybe(types.string),
  location: types.maybe(types.string),
  phone: types.maybe(types.string),
  faxNumber: types.maybe(types.string),
  particularAccompanyingPerson: types.maybe(types.string),

  get formFields() {
    return {
      fields: {
        name: {
          label: 'Name',
          name: 'name',
          placeholder: 'Enter Full Name',
          rules: 'required',
          type: 'text',
          value: this.name
        },
        specialty: {
          label: 'Specialty',
          name: 'specialty',
          placeholder: 'Enter Specialty',
          type: 'text',
          value: this.specialty
        },
        institution: {
          label: 'Institution/Organization',
          name: 'institution',
          placeholder: 'Enter Institution/Organization',
          type: 'text',
          value: this.institution
        },
        mobile: {
          label: 'Mobile',
          name: 'mobile',
          placeholder: 'Enter Mobile Number',
          type: 'text',
          value: this.mobile
        },
        email: {
          label: 'Email',
          name: 'email',
          rules: 'email',
          placeholder: 'Enter Email Address',
          type: 'text',
          value: this.email
        },
        numberOfAccompanyingPerson: {
          label: 'Number of accompanying person(s)',
          name: 'numberOfAccompanyingPerson',
          placeholder: 'Enter Number of accompanying person',
          type: 'select',
          extra: {
            options: [
              { value: 'enclosed', label: 'Enclosed' },
              { value: 'not enclosed', label: 'Not Enclosed' },
              { value: 'not applicable', label: 'Not Applicable' }
            ]
          },
          value: this.numberOfAccompanyingPerson
        },
        abstract: {
          label: 'Abstract',
          name: 'abstract',
          placeholder: 'Select',
          type: 'select',
          extra: {
            options: [
              { value: '1', label: '1' },
              { value: '2', label: '2' },
              { value: '3', label: '3' },
              { value: '4', label: '4' },
              { value: '5', label: '5' }
            ]
          },
          value: this.abstract
        },
        degree: {
          label: 'Degree/ Diploma/ Fellowship',
          name: 'degree',
          placeholder: 'Enter Degree/ Diploma/ Fellowship',
          type: 'text',
          value: this.degree
        },
        designation: {
          label: 'Designation',
          name: 'designation',
          placeholder: 'Enter Designation',
          type: 'text',
          value: this.designation
        },
        location: {
          label: 'Location',
          name: 'location',
          placeholder: 'Enter Location',
          type: 'text',
          value: this.location
        },
        phone: {
          label: 'Phone',
          name: 'phone',
          placeholder: 'Enter Contact Number',
          type: 'text',
          value: this.phone
        },
        faxNumber: {
          label: 'Fax',
          name: 'faxNumber',
          placeholder: 'Enter Fax Number',
          type: 'text',
          value: this.faxNumber
        },
        particularAccompanyingPerson: {
          label: 'Paticulars of the accompanying persons (if any)',
          name: 'particularAccompanyingPerson',
          placeholder: 'Enter particular accompanuing person',
          type: 'text',
          value: this.particularAccompanyingPerson
        }
      }
    };
  }
});

export default app => createService(app, Registration.name);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/services/Registration.ts